@if (layoutConfig$ | async; as config) {
  @let layoutContext = layoutContext$ | async;
  <div
    class="flex flex-1"
    data-id="layout-root"
    [ngClass]="{ 'pointer-events-none': trialPopoverStore.isTrialExpired() }"
  >
    @if (config.sidebar; as sidebarConfig) {
      <bd-sidebar
        class="bd-sidebar"
        [ngClass]="{
          'bd-overlayed': layoutContext === 'overlay',
        }"
        [sidebarConfig]="sidebarConfig"
        [appVersion]="(appVersion$ | async) ?? undefined"
      ></bd-sidebar>
    }
    <div class="flex flex-col flex-1 min-w-0">
      @if (config.header; as headerConfig) {
        <bd-header
          [headerConfig]="headerConfig"
          [ngClass]="{
            'bd-overlayed': layoutContext === 'overlay',
          }"
        ></bd-header>
      }
      <div data-id="layout-content" class="flex flex-1">
        @let left = drawerStore.leftDrawer();
        @if (left && left.template) {
          <bd-drawer
            [@slideInOut]="drawerStore.leftDrawer()?.state ?? 'out'"
            (@slideInOut.done)="
              drawerStore.onAnimationDone('left', $event.toState)
            "
            [@.disabled]="!config.drawer.animation"
            [ngClass]="{
              'bd-drawer-collapsed': left.state === 'out',
              '!relative': config.drawer.effect === 'push',
              '!absolute': config.drawer.effect === 'overlay',
              'bd-float-header-drawer': config.header.position === 'float',
            }"
            class="bd-drawer-left bg-white bd-drawer-box-shadow"
            [template]="left.template"
          ></bd-drawer>
        }
        <div
          class="flex-1 shrink"
          [ngClass]="{
            'bd-page-layout': config.pageLayout,
            'bd-overlayed': layoutContext === 'overlay',
          }"
        >
          <router-outlet></router-outlet>
        </div>
        @let right = drawerStore.rightDrawer();
        @let isAiDrawer = right?.key === 'aiAssistant';

        @if (right && right.template) {
          <bd-drawer
            [@slideInOut]="drawerStore.rightDrawer()?.state ?? 'out'"
            (@slideInOut.done)="
              drawerStore.onAnimationDone('right', $event.toState)
            "
            [@.disabled]="!config.drawer.animation"
            [ngClass]="{
              'bd-drawer-with-backdrop':
                contentDetailsGlobalStore.showDrawerBackdrop(),
              'bd-drawer-collapsed': right.state === 'out',
              '!relative': config.drawer.effect === 'push',
              '!absolute': config.drawer.effect === 'overlay',
              'bd-float-header-drawer': config.header.position === 'float',
              'bd-short-drawer': config.footer,
              'bd-drawer-box-shadow': !isAiDrawer,
              '!bg-transparent !pointer-events-none': isAiDrawer,
              'bd-drawer-small': isAiDrawer,
            }"
            class="bd-drawer-right bg-white"
            [bdBeaconOccluder]="isAiDrawer && right.state !== 'out'"
            [template]="right.template"
            [size]="'regular'"
          ></bd-drawer>
        }

        <!-- Outside the @if above: this template is what registers the drawer,
             so nesting it there would leave the assistant unable to open on a
             page where no other right drawer has registered first. -->
        <ng-template
          #aiAssistant
          bdKey="aiAssistant"
          [bdDrawer]="aiAssistant"
          [drawerPosition]="'right'"
          [drawerExclusive]="true"
          [drawerState]="
            aiAssistantV2Store.isAssistantPanelVisible()
              ? { visible: true }
              : { visible: false }
          "
        >
          <bd-ai-assistant-container-v2 />
        </ng-template>

        <div
          [ngClass]="{ 'bd-overlay-backdrop': layoutContext === 'overlay' }"
          [attr.aria-hidden]="layoutContext === 'overlay' ? 'true' : null"
        >
          <div
            [ngClass]="{
              'bd-overlay': layoutContext === 'overlay',
              'bd-overlay-v5': layoutContext === 'overlay',
            }"
          >
            <router-outlet name="overlay"></router-outlet>
          </div>
        </div>
      </div>
      @if (config?.footer) {
        <bd-footer />
      }
    </div>
  </div>
} @else {
  <bd-loader></bd-loader>
}
<bd-toast></bd-toast>
@if (featureFlags.trialExperienceEnabled()) {
  <bd-trial-dev-menu context="product" />
  <bd-trial-expired-dialog />
}
